import { Box, WizardStepRenderParams, useOnNext } from '@factorialco/deprecated-design-system'
import { F0Alert, F0Card } from '@factorialco/f0-react'
import { Building } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

import { WizardData } from 'modules/banking/components/NewAccountModal/types'
import { WizardStepLayout } from 'modules/banking/components/NewAccountModal/wizardSteps/WizardStepLayout'

export const BankAccountConnectionWizardStepF0 = ({ data }: WizardStepRenderParams<WizardData>) => {
  // As there is another step using this.. we have to override the onNext callback
  // Must be called before any early returns per React hooks rules
  useOnNext(() => Promise.resolve())

  if (!data.institution) {
    return null
  }

  const maxDays = Math.min(data.institution.transactionTotalDays, 180).toString()

  return (
    <WizardStepLayout
      title={i18n.t('banking.accounts.new_wizard.step_3_1.title')}
      subtitle={i18n.t('banking.accounts.new_wizard.step_3_1.subtitle')}
    >
      <Box width="full" flexDirection="column" gap="s16" style={{ maxWidth: '500px' }}>
        <F0Card
          title={data.legalEntity?.legalName || '-'}
          description={i18n.t('banking.accounts.new_wizard.step_1.title')}
          avatar={{ type: 'icon', icon: Building }}
          compact
        />
        <F0Card
          title={data.institution.name}
          description={i18n.t('finance.chart_of_accounts.types.bank')}
          avatar={{ type: 'company', name: data.institution.name, src: data.institution.logo }}
          compact
        />
        <F0Alert
          variant="info"
          title={i18n.t('banking.accounts.new_wizard.step_3_1.callout_title')}
          description={i18n.t('banking.accounts.new_wizard.step_3_1.callout_description', {
            days: maxDays,
          })}
        />
        <F0Alert
          variant="warning"
          title={i18n.t('banking.accounts.new_wizard.step_3_1.security_title')}
          description={i18n.t('banking.accounts.new_wizard.step_3_1.security_description')}
        />
      </Box>
    </WizardStepLayout>
  )
}
